/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PanelSection } from '../models/panel-section';
import { ParametreDto } from '../models/parametre-dto';
import { ParametresAzureDto } from '../models/parametres-azure-dto';
import { ParametresCalendrierDto } from '../models/parametres-calendrier-dto';
import { ParametresEmailDto } from '../models/parametres-email-dto';
import { ParametresGlobauxDto } from '../models/parametres-globaux-dto';
import { ParametresGoogleDto } from '../models/parametres-google-dto';
import { ParametresJokerDto } from '../models/parametres-joker-dto';
import { ParametresRepresentantDto } from '../models/parametres-representant-dto';
import { ParametresServicesDto } from '../models/parametres-services-dto';


/**
 * Fonctions du panneau de contrôle
 */
@Injectable({
  providedIn: 'root',
})
export class PanelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation panelGetMenuSections
   */
  static readonly PanelGetMenuSectionsPath = '/api/panel/sections';

  /**
   * Renvoie la section de menu pour créer le menu de gauche du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetMenuSections()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetMenuSections$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PanelSection>>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetMenuSectionsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PanelSection>>;
      })
    );
  }

  /**
   * Renvoie la section de menu pour créer le menu de gauche du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetMenuSections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetMenuSections(params?: {
  }): Observable<Array<PanelSection>> {

    return this.panelGetMenuSections$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PanelSection>>) => r.body as Array<PanelSection>)
    );
  }

  /**
   * Path part for operation panelGetServicesParams
   */
  static readonly PanelGetServicesParamsPath = '/api/panel/params/services';

  /**
   * Renvoie les paramètres globaux du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetServicesParams()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetServicesParams$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresServicesDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetServicesParamsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresServicesDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres globaux du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetServicesParams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetServicesParams(params?: {
  }): Observable<ParametresServicesDto> {

    return this.panelGetServicesParams$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresServicesDto>) => r.body as ParametresServicesDto)
    );
  }

  /**
   * Path part for operation panelGetParams
   */
  static readonly PanelGetParamsPath = '/api/panel/params';

  /**
   * Renvoie les paramètres globaux du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetParams()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetParams$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresGlobauxDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetParamsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresGlobauxDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres globaux du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetParams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetParams(params?: {
  }): Observable<ParametresGlobauxDto> {

    return this.panelGetParams$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresGlobauxDto>) => r.body as ParametresGlobauxDto)
    );
  }

  /**
   * Path part for operation panelUpdateParams
   */
  static readonly PanelUpdateParamsPath = '/api/panel/params';

  /**
   * Met à jour les paramètres globaux du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateParams()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateParams$Response(params: {

    /**
     * Paramètres globaux
     */
    body: ParametresGlobauxDto
  }): Observable<StrictHttpResponse<ParametresGlobauxDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateParamsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresGlobauxDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres globaux du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateParams$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateParams(params: {

    /**
     * Paramètres globaux
     */
    body: ParametresGlobauxDto
  }): Observable<ParametresGlobauxDto> {

    return this.panelUpdateParams$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresGlobauxDto>) => r.body as ParametresGlobauxDto)
    );
  }

  /**
   * Path part for operation panelGetAllParams
   */
  static readonly PanelGetAllParamsPath = '/api/panel/params/all';

  /**
   * Renvoie tous les paramètres.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetAllParams()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetAllParams$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ParametreDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetAllParamsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParametreDto>>;
      })
    );
  }

  /**
   * Renvoie tous les paramètres.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetAllParams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetAllParams(params?: {
  }): Observable<Array<ParametreDto>> {

    return this.panelGetAllParams$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParametreDto>>) => r.body as Array<ParametreDto>)
    );
  }

  /**
   * Path part for operation panelUpdateAllParams
   */
  static readonly PanelUpdateAllParamsPath = '/api/panel/params/all';

  /**
   * Met à jour les paramètres.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateAllParams()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateAllParams$Response(params: {

    /**
     * Paramètres à mettre à jour
     */
    body: Array<ParametreDto>
  }): Observable<StrictHttpResponse<Array<ParametreDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateAllParamsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParametreDto>>;
      })
    );
  }

  /**
   * Met à jour les paramètres.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateAllParams$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateAllParams(params: {

    /**
     * Paramètres à mettre à jour
     */
    body: Array<ParametreDto>
  }): Observable<Array<ParametreDto>> {

    return this.panelUpdateAllParams$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParametreDto>>) => r.body as Array<ParametreDto>)
    );
  }

  /**
   * Path part for operation panelGetParamsAzure
   */
  static readonly PanelGetParamsAzurePath = '/api/panel/params/azure';

  /**
   * Renvoie les paramètres d'accès au portail Azure pour authentification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetParamsAzure()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetParamsAzure$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresAzureDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetParamsAzurePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresAzureDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres d'accès au portail Azure pour authentification.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetParamsAzure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetParamsAzure(params?: {
  }): Observable<ParametresAzureDto> {

    return this.panelGetParamsAzure$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresAzureDto>) => r.body as ParametresAzureDto)
    );
  }

  /**
   * Path part for operation panelUpdateParamsAzure
   */
  static readonly PanelUpdateParamsAzurePath = '/api/panel/params/azure';

  /**
   * Met à jour les paramètres d'accès au portail Azure pour authentification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateParamsAzure()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateParamsAzure$Response(params: {

    /**
     * Paramètres Azure
     */
    body: ParametresAzureDto
  }): Observable<StrictHttpResponse<ParametresAzureDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateParamsAzurePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresAzureDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres d'accès au portail Azure pour authentification.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateParamsAzure$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateParamsAzure(params: {

    /**
     * Paramètres Azure
     */
    body: ParametresAzureDto
  }): Observable<ParametresAzureDto> {

    return this.panelUpdateParamsAzure$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresAzureDto>) => r.body as ParametresAzureDto)
    );
  }

  /**
   * Path part for operation panelGetParamsCalendrier
   */
  static readonly PanelGetParamsCalendrierPath = '/api/panel/params/calendrier';

  /**
   * Renvoie les paramètres calendrier du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetParamsCalendrier()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetParamsCalendrier$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresCalendrierDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetParamsCalendrierPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresCalendrierDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres calendrier du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetParamsCalendrier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetParamsCalendrier(params?: {
  }): Observable<ParametresCalendrierDto> {

    return this.panelGetParamsCalendrier$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresCalendrierDto>) => r.body as ParametresCalendrierDto)
    );
  }

  /**
   * Path part for operation panelUpdateParamsCalendrier
   */
  static readonly PanelUpdateParamsCalendrierPath = '/api/panel/params/calendrier';

  /**
   * Met à jour les paramètres calendrier du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateParamsCalendrier()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateParamsCalendrier$Response(params: {

    /**
     * Paramètres calendrier
     */
    body: ParametresCalendrierDto
  }): Observable<StrictHttpResponse<ParametresCalendrierDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateParamsCalendrierPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresCalendrierDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres calendrier du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateParamsCalendrier$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateParamsCalendrier(params: {

    /**
     * Paramètres calendrier
     */
    body: ParametresCalendrierDto
  }): Observable<ParametresCalendrierDto> {

    return this.panelUpdateParamsCalendrier$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresCalendrierDto>) => r.body as ParametresCalendrierDto)
    );
  }

  /**
   * Path part for operation panelGetEmail
   */
  static readonly PanelGetEmailPath = '/api/panel/email';

  /**
   * Renvoie les paramètres E-mails du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetEmail$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresEmailDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetEmailPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresEmailDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres E-mails du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetEmail(params?: {
  }): Observable<ParametresEmailDto> {

    return this.panelGetEmail$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresEmailDto>) => r.body as ParametresEmailDto)
    );
  }

  /**
   * Path part for operation panelUpdateEmail
   */
  static readonly PanelUpdateEmailPath = '/api/panel/email';

  /**
   * Met à jour les paramètres E-mails du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateEmail$Response(params: {

    /**
     * Paramètres E-mails
     */
    body: ParametresEmailDto
  }): Observable<StrictHttpResponse<ParametresEmailDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresEmailDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres E-mails du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateEmail(params: {

    /**
     * Paramètres E-mails
     */
    body: ParametresEmailDto
  }): Observable<ParametresEmailDto> {

    return this.panelUpdateEmail$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresEmailDto>) => r.body as ParametresEmailDto)
    );
  }

  /**
   * Path part for operation panelGetGoogle
   */
  static readonly PanelGetGooglePath = '/api/panel/google';

  /**
   * Renvoie les paramètres Google du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetGoogle()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetGoogle$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresGoogleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetGooglePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresGoogleDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres Google du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetGoogle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetGoogle(params?: {
  }): Observable<ParametresGoogleDto> {

    return this.panelGetGoogle$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresGoogleDto>) => r.body as ParametresGoogleDto)
    );
  }

  /**
   * Path part for operation panelUpdateGoogle
   */
  static readonly PanelUpdateGooglePath = '/api/panel/google';

  /**
   * Met à jour les paramètres relatifs aux API Google.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateGoogle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateGoogle$Response(params: {

    /**
     * Paramètres Google
     */
    body: ParametresGoogleDto
  }): Observable<StrictHttpResponse<ParametresGoogleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateGooglePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresGoogleDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres relatifs aux API Google.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateGoogle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateGoogle(params: {

    /**
     * Paramètres Google
     */
    body: ParametresGoogleDto
  }): Observable<ParametresGoogleDto> {

    return this.panelUpdateGoogle$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresGoogleDto>) => r.body as ParametresGoogleDto)
    );
  }

  /**
   * Path part for operation panelGetJoker
   */
  static readonly PanelGetJokerPath = '/api/panel/joker';

  /**
   * Renvoie les paramètres Jokers du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetJoker()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetJoker$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresJokerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetJokerPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresJokerDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres Jokers du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetJoker$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetJoker(params?: {
  }): Observable<ParametresJokerDto> {

    return this.panelGetJoker$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresJokerDto>) => r.body as ParametresJokerDto)
    );
  }

  /**
   * Path part for operation panelUpdateJoker
   */
  static readonly PanelUpdateJokerPath = '/api/panel/joker';

  /**
   * Met à jour les paramètres relatifs aux jokers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateJoker()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateJoker$Response(params: {

    /**
     * Paramètres Jokers
     */
    body: ParametresJokerDto
  }): Observable<StrictHttpResponse<ParametresJokerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateJokerPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresJokerDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres relatifs aux jokers.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateJoker$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateJoker(params: {

    /**
     * Paramètres Jokers
     */
    body: ParametresJokerDto
  }): Observable<ParametresJokerDto> {

    return this.panelUpdateJoker$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresJokerDto>) => r.body as ParametresJokerDto)
    );
  }

  /**
   * Path part for operation panelGetRepresentant
   */
  static readonly PanelGetRepresentantPath = '/api/panel/representant';

  /**
   * Renvoie les paramètres Representant du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetRepresentant()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetRepresentant$Response(params?: {
  }): Observable<StrictHttpResponse<ParametresRepresentantDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetRepresentantPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresRepresentantDto>;
      })
    );
  }

  /**
   * Renvoie les paramètres Representant du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetRepresentant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetRepresentant(params?: {
  }): Observable<ParametresRepresentantDto> {

    return this.panelGetRepresentant$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresRepresentantDto>) => r.body as ParametresRepresentantDto)
    );
  }

  /**
   * Path part for operation panelUpdateRepresentant
   */
  static readonly PanelUpdateRepresentantPath = '/api/panel/representant';

  /**
   * Met à jour les paramètres relatifs aux représentants/représentés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUpdateRepresentant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateRepresentant$Response(params: {

    /**
     * Paramètres Représentant
     */
    body: ParametresRepresentantDto
  }): Observable<StrictHttpResponse<ParametresRepresentantDto>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUpdateRepresentantPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParametresRepresentantDto>;
      })
    );
  }

  /**
   * Met à jour les paramètres relatifs aux représentants/représentés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUpdateRepresentant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  panelUpdateRepresentant(params: {

    /**
     * Paramètres Représentant
     */
    body: ParametresRepresentantDto
  }): Observable<ParametresRepresentantDto> {

    return this.panelUpdateRepresentant$Response(params).pipe(
      map((r: StrictHttpResponse<ParametresRepresentantDto>) => r.body as ParametresRepresentantDto)
    );
  }

  /**
   * Path part for operation panelGetLogo
   */
  static readonly PanelGetLogoPath = '/api/panel/logo';

  /**
   * Renvoie le logo du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelGetLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetLogo$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelGetLogoPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Renvoie le logo du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelGetLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelGetLogo(params?: {
  }): Observable<Blob> {

    return this.panelGetLogo$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation panelUploadLogo
   */
  static readonly PanelUploadLogoPath = '/api/panel/logo';

  /**
   * Modifie le logo du panneau de contrôle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelUploadLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelUploadLogo$Response(params?: {
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelUploadLogoPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Modifie le logo du panneau de contrôle.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelUploadLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelUploadLogo(params?: {
  }): Observable<boolean> {

    return this.panelUploadLogo$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation panelClearCache
   */
  static readonly PanelClearCachePath = '/api/panel/params/clear-cache';

  /**
   * Vide le cache des paramètres.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `panelClearCache()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelClearCache$Response(params?: {
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PanelService.PanelClearCachePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Vide le cache des paramètres.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `panelClearCache$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  panelClearCache(params?: {
  }): Observable<boolean> {

    return this.panelClearCache$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
